export default {
    "TABLE": {
        "COUNT": "{from} -tól {to} -ig rekordok mutatása|{count} rekord|Egy rekord",
        "ACTIONS": "Műveletek",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/table.js